import React from 'react';

export const PollingPlace = () => {
  return (
    <div>
      <h1>this is the Polling Place page</h1>
    </div>
  );
};
